exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bulk-actions-remove-from-connect-modal .cu-alert {\n  margin-bottom: 0px;\n}\n", ""]);

